<template>
  <v-dialog
    v-model="visible"
    width="80%"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    scrollable
    content-class="elevation-0"
  >
    <v-card class="rounded-xl">
      <v-card-title>
        Kontakt erstellen
        <v-spacer></v-spacer>
        <v-btn icon @click="close()"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

      <v-divider></v-divider>

      <v-card-text class="py-4">
        <v-row no-gutters>
          <v-col class="pa-1" cols="12" lg="6">
            <v-card outlined height="100%">
              <v-card-title class="py-1">Kontaktdaten</v-card-title>
              <v-divider></v-divider>
              <v-row no-gutters class="ma-2">
                <uiKontaktField
                  v-for="(item, index) in felder.neuFelder"
                  :key="index"
                  :feld="item"
                  :value="bbr[item.value]"
                  @dataChange="saveData(...arguments)"
                ></uiKontaktField>
              </v-row>
            </v-card>
          </v-col>
          <v-col class="pa-1" cols="12" lg="6">
            <v-card outlined height="100%">
              <v-card-title class="py-1">Finanzdaten</v-card-title>
              <v-divider></v-divider>
              <v-row class="ma-2">
                <v-col cols="12" class="py-1 px-1" v-if="felder.finanzFelder.showSepaMandat">
                  <v-card outlined>
                    <span class="d-flex justify-start align-center pr-2">
                      <span class="pa-2">
                        <v-icon v-if="bbr.sepaLastschriftmandat" size="64" color="green">check_circle_outline</v-icon>
                        <v-icon v-else size="64" color="red">highlight_off</v-icon>
                      </span>
                      <span>
                        <v-card-title class="subtitle-2"> SEPA-Lastschriftmandat </v-card-title>
                        <v-card-subtitle v-if="bbr.sepaLastschriftmandat">
                          {{ $filters.date(bbr.sepaLastschriftmandat.date, "hh:mm DD.MM.YYYY") }} Uhr
                        </v-card-subtitle>
                        <v-card-subtitle v-else>
                          Aktuell wurde noch kein SEPA-Lastschriftmandat hochgeladen.
                        </v-card-subtitle>
                      </span>
                      <v-spacer></v-spacer>
                      <span v-if="bbr.sepaLastschriftmandat">
                        <v-btn icon @click="downloadLastschrift(bbr.sepaLastschriftmandat)"
                          ><v-icon>download</v-icon></v-btn
                        >
                      </span>
                      <span v-else>
                        <v-btn
                          color="primary"
                          class="text-none"
                          :loading="loadingLaschriftmandatHochladen"
                          @click="clickHochladenLastschriftmandat()"
                        >
                          <v-icon left>cloud_upload</v-icon>Hochladen
                        </v-btn>
                        <input ref="uploader" class="d-none" type="file" accept="pdf/*" @change="onFileChanged" />
                      </span>
                    </span>
                    <v-progress-linear
                      v-if="loadingLaschriftmandatHochladen"
                      indeterminate
                      color="primary"
                    ></v-progress-linear>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <uiKontaktField
                  v-for="(item, index) in felder.finanzFelder.beitrage"
                  :key="index"
                  :feld="item"
                  :value="bbr[item.value]"
                  @dataChange="saveData(...arguments)"
                ></uiKontaktField>
              </v-row>
              <v-row>
                <v-col v-if="felder.finanzFelder.showBankdaten" cols="12" sm="6" class="py-1 px-1">
                  <v-text-field
                    hide-details="auto"
                    dense
                    outlined
                    :loading="loading_checkIban"
                    @change="checkIban()"
                    label="IBAN"
                    v-model="bbr.iban"
                  ></v-text-field>
                </v-col>
                <v-col v-if="felder.finanzFelder.showBankdaten" cols="12" sm="6" class="py-1 px-1">
                  <v-text-field
                    hide-details="auto"
                    dense
                    outlined
                    disabled
                    label="BIC"
                    placeholder="Automatisch berechnet"
                    v-model="bbr.bic"
                  ></v-text-field>
                </v-col>
                <v-col v-if="felder.finanzFelder.showBankdaten" cols="12" sm="6" class="py-1 px-1">
                  <v-text-field
                    hide-details="auto"
                    dense
                    outlined
                    label="Kontoinhaber"
                    v-model="bbr.kontoinhaber"
                    :append-icon="bbr.kontoinhaber ? '' : 'refresh'"
                    @click:append="bbr.kontoinhaber = bbr.vorname + ' ' + bbr.nachname"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>
                <v-col v-if="felder.finanzFelder.showBankdaten" cols="12" sm="6" class="py-1 px-1">
                  <v-text-field
                    hide-details="auto"
                    dense
                    outlined
                    label="Mandatsreferenz"
                    v-model="bbr.mandatsreferenz"
                    :append-icon="bbr.mandatsreferenz ? '' : 'refresh'"
                    @click:append="calcMandatsreferenz()"
                  ></v-text-field>
                </v-col>
                <uiKontaktField
                  v-if="felder.finanzFelder.showBankdaten"
                  :feld="{ breite: 6, label: 'Mandat Unterschriftsdatum', type: 'Date' }"
                  :value="bbr['mandatUnterschriftsdatum']"
                  @dataChange="saveData(...arguments)"
                ></uiKontaktField>
                <uiKontaktField
                  v-if="felder.finanzFelder.showBankdaten"
                  :feld="{ breite: 6, label: 'Letzter Lastschrifteinzug', type: 'Date' }"
                  :value="bbr['letzterLastschrifteinzug']"
                  @dataChange="saveData(...arguments)"
                ></uiKontaktField>
                <v-col cols="12" v-if="fehlerSepa.sepa" class="pa-1">
                  <v-alert type="error">{{ fehlerSepa.sepa }}</v-alert>
                </v-col>
              </v-row>
              <span v-if="felder.finanzFelder.showSepaMandat">
                <v-card-title class="py-1 mt-6">SEPA-Einstellungen</v-card-title>
                <v-card-subtitle class="py-1">Welche Kassen dürfen per SEPA Rechnungen einziehen?</v-card-subtitle>
                <v-divider></v-divider>
                <v-row no-gutters class="ma-2">
                  <v-col cols="12" class="py-1 px-1" v-if="disableSEPA">
                    <v-card outlined>
                      <span class="d-flex justify-start align-center pr-2">
                        <span class="pa-2">
                          <v-icon size="64" color="red">warning_amber</v-icon>
                        </span>
                        <span>
                          <v-card-title class="subtitle-2"> Kontodaten fehlen! </v-card-title>
                          <v-card-subtitle>
                            Damit ein SEPA-Einzug für einen Kontakt eingestellt werden kann, müssen zuerst die
                            Kontodaten eingetragen werden.
                          </v-card-subtitle>
                        </span>
                      </span>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-1 px-1"
                    v-for="(item, index) in kassen"
                    :key="index"
                    v-if="item.name"
                  >
                    <v-checkbox
                      dense
                      hide-details
                      class="mb-0 pb-0"
                      :disabled="disableSEPA"
                      on-icon="check_box"
                      off-icon="check_box_outline_blank"
                      v-model="sepa[item.name]"
                      :label="item.name"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </span>
            </v-card>
          </v-col>
          <v-col class="pa-1" cols="12">
            <v-card outlined height="100%">
              <v-row no-gutters class="ma-2">
                <v-col cols="12" class="py-1 px-1">
                  <v-textarea
                    hide-details="auto"
                    dense
                    outlined
                    hint="Bemerkungen werden nur den Chargen und Ämtern angezeigt, die Zugriff auf die Kontaktbearbeitung haben."
                    rows="5"
                    auto-grow
                    label="Bemerkungen"
                    v-model="bbr.bemerkungen"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn text rounded @click="close()">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <span class="text-caption" v-if="pflichtfelder.length > 0"
          >Folgende Felder müssen noch ausgefüllt werden:<br />
          <v-chip small label v-for="(item, index) in pflichtfelder" :key="index" class="mr-1 mt-1">{{ item }}</v-chip>
        </span>
        <v-spacer></v-spacer>
        <v-btn class="primary" rounded @click="save()" :disabled="pflichtfelder.length > 0">Speichern</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showPicture" width="50%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-card-title>
          Ahnengalerie - {{ bbr.titel }} {{ bbr.vorname }} {{ bbr.nachname }}
          <v-spacer></v-spacer>
          <v-btn icon @click="showPicture = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>

        <v-divider></v-divider>

        <v-card-text class="pa-0 ma-0">
          <v-row no-gutters>
            <v-col class="pa-1" cols="4" offset="2">
              <v-card outlined height="100%">
                <v-card-title> Aktuelles Bild </v-card-title>
                <v-img :src="bbr.bildAhnengalerie" width="100%" @click="showPicture = true"></v-img>
              </v-card>
            </v-col>
            <v-col class="pa-1" cols="4">
              <v-card outlined height="100%">
                <v-card-title> Neues Bild </v-card-title>
                <v-file-input
                  prepend-icon="attach_file"
                  v-model="selectPicture"
                  label="Neues Bild"
                  @change="previewImage"
                ></v-file-input>
                <v-card-action class="text-center">
                  <v-divider v-if="message"></v-divider>
                  {{ message }}
                </v-card-action>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showPicture = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
  import axios from "axios";
  export default {
    props: ["status", "visible"],
    data() {
      return {
        bbr: {},
        sepa: {},
        itemsAnrede: ["Herr", "Frau", "Familie"],
        selectVerbindung: [
          "AV Alania Stuttgart",
          "AV Alsatia Münster",
          "AV Cheruscia Münster",
          "AV Cheruskia Tübingen",
          "AV Frisia Hannover",
          "AV Glückauf-Salia Clausthal-Zellerfeld",
          "AV Guestfalia Tübingen",
          "AV Hansea (Berlin) Köln",
          "AV Palatia Göttingen",
          "AV Rheinstein Köln",
          "AV Rheno-Guestfalia Kiel",
          "AV Salia-Silesia Gleiwitz",
          "AV Silesia (Halle, Bonn) Bochum",
          "AV Sparrenberg Bielefeld",
          "AV Suebo-Danubia Ulm",
          "AV Tuisconia (Königsberg, Bonn) Landshut",
          "AV Widukind Osnabrück",
          "AV Zollern Münster",
          "CV-Verbindung Rheno-Palatia (Breslau) Mainz",
          "FAV Rheno-Guestfalia (Hann. Münden) Göttingen",
          "KAV Capitolina Rom",
          "KAV Suevia Berlin",
          "KDStV Adolphiana Fulda",
          "KDStV Aenania München",
          "KDStV Agilolfia Freising",
          "KDStV Alania Bonn",
          "KDStV Alcimonia Eichstätt",
          "KDStV Alemannia Greifswald und Münster",
          "KDStV Algovia Augsburg",
          "KDStV Angrivaria (Sarstedt, Hannover) Dortmund",
          "KDStV Arminia Freiburg im Breisgau",
          "KDStV Arminia Heidelberg",
          "KDStV Ascania Bonn",
          "KDStV Asgard (Düsseldorf) Köln",
          "KDStV Aureo-Danubia Ingolstadt",
          "KDStV Badenia (Straßburg) Frankfurt am Main",
          "KDStV Baltia (Danzig) Aachen",
          "KDStV Bavaria Berlin",
          "KDStV Bavaria Bonn",
          "KDStV Bergisch-Thuringia Wuppertal",
          "KDStV Bergland (Freiberg) Aachen",
          "KDStV Bodensee Konstanz",
          "KDStV Borusso-Saxonia Berlin",
          "KDStV Borusso-Westfalia Bonn",
          "KDStV Burgundia (Leipzig) Düsseldorf",
          "KDStV Burgundia München",
          "KDStV Carolingia Hohenheim",
          "KDStV Carolus Magnus Saarbrücken",
          "KDStV Cheruscia Würzburg",
          "KDStV Churpfalz Mannheim",
          "KDStV Chursachsen Dresden",
          "KDStV Churtrier Trier",
          "KDStV Elbmark (Tetschen-Liebwerd) Duisburg",
          "KDStV Falkenstein Freiburg im Breisgau",
          "KDStV Ferdinandea (Prag) Heidelberg",
          "KDStV Franco-Raetia Würzburg",
          "KDStV Franconia Aachen",
          "KDStV Frankonia (Czernowitz) Erlangen",
          "KDStV Fredericia Bamberg",
          "KDStV Germania Leipzig",
          "KDStV Gothia Erlangen",
          "KDStV Gothia Würzburg",
          "KDStV Greiffenstein (Breslau) Frankfurt",
          "KDStV Guestfalo-Silesia Paderborn",
          "KDStV Hasso-Nassovia Frankfurt am Main",
          "KDStV Hercynia Freiburg im Breisgau",
          "KDStV Hohenstaufen Freiburg im Breisgau",
          "KDStV Kaiserpfalz Aachen",
          "KDStV Langobardia (München) Bayreuth",
          "KDStV Makaria (Berlin) Aachen",
          "KDStV Marchia (Breslau) Aachen",
          "KDStV Markomannia Würzburg",
          "KDStV Merowingia Kaiserslautern",
          "KDStV Moenania München",
          "KDStV Moeno-Franconia Frankfurt am Main",
          "KDStV Nassovia Darmstadt",
          "KDStV Nibelungia (Brünn) Darmstadt",
          "KDStV Niedersachsen Braunschweig",
          "KDStV Norbertina Magdeburg",
          "KDStV Nordgau (Prag, Stuttgart) Koblenz",
          "KDStV Nordmark (Rostock, Karlsruhe) Essen",
          "KDStV Normannia Karlsruhe",
          "KDStV Novesia Bonn",
          "KDStV Oeno-Danubia Passau",
          "KDStV Ostmark Nürnberg",
          "KDStV Palatia Marburg",
          "KDStV Palatina Amberg/Weiden",
          "KDStV Radaspona (Regensburg) München",
          "KDStV Rappoltstein (Straßburg) Köln",
          "KDStV Rheinland Köln",
          "KDStV Rheinpfalz Darmstadt",
          "KDStV Rhenania-Moguntia Mainz",
          "KDStV Rheno-Baltia Köln",
          "KDStV Rheno-Franconia München",
          "KDStV Rheno-Saxonia (Köthen) Halle",
          "KDStV Ripuaria Aachen",
          "KDStV Ripuaria Bonn",
          "KDStV Ripuaria Freiburg im Breisgau",
          "KDStV Rupertia Regensburg",
          "KDStV Saarland (Saarbrücken) Jena",
          "KDStV Sauerlandia Münster",
          "KDStV Saxo-Silesia Hannover",
          "KDStV Saxo-Thuringia (Dresden, Aachen) Bochum",
          "KDStV Schwarzwald Karlsruhe",
          "KDStV Seraphina Lippstadt",
          "KDStV Staufia Bonn",
          "KDStV Sugambria (Jena) Göttingen",
          "KDStV Teuto-Rhenania Hannover",
          "KDStV Teutonia Freiburg im Üechtland",
          "KDStV Thuringia Würzburg",
          "KDStV Trifels München",
          "KDStV Tuiskonia München",
          "KDStV Vandalia (Prag) München",
          "KDStV Vasgovia Landau",
          "KDStV Vindelicia München",
          "KDStV Welfia Weingarten",
          "KDStV Wiking Hamburg",
          "KDStV Wildenstein Freiburg im Breisgau",
          "KDStV Winfridia (Breslau) Münster",
          "KStV Thuringia Coburg",
          "KTV Visurgis Bremen",
          "VKDSt Hasso-Rhenania Gießen",
          "VKDSt Hasso-Rhenania Mainz",
          "VKDSt Rhenania Marburg",
          "VKDSt Saxonia Münster",
        ],
        itemsBriefanrede: [
          "Lieber Bundesbruder",
          "Sehr geehrter Cartellbruder",
          "Sehr geehrter Farbenbruder",
          "Sehr geehrter Herr",
          "Sehr geehrte Frau",
          "Sehr geehrte Damen und Herren",
          "Liebe",
          "Lieber",
        ],
        date: "",
        menu1: "",
        menu2: "",
        menu3: "",
        menu4: "",
        menu5: "",
        menu6: "",
        menu7: "",
        menu8: "",
        pflichtfelder: [],
        menuFeldVar: "",
        loading_checkIban: false,
        selectedFile: null,
        loadingLaschriftmandatHochladen: false,
        selectPicture: "",
        showPicture: false,
        uploadValue: "",
        fehlerSepa: {},
        img1: "",
        imageData: "",
        message: "",
        rules: {
          required: (value) => !!value || "",
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Flasches E-Mail-Format";
          },
          telefonnummer: (value) => {
            const pattern = /^\+([0-9]){2}[ ][1-9]([0-9]){2}[0-9]?[ ]([0-9]?){12}$/g;
            return pattern.test(value) || "Flasches Telefonnummern-Format. Es muss +49 123 456789123 entsprechen";
          },
          geld: (value) => {
            const pattern = /^[0-9]([0-9]?){10}([.]([0-9]?){2})?$/g;
            return pattern.test(value) || "Flasches Format. Es muss 13.45 entsprechen";
          },
        },
      };
    },
    computed: {
      itemsStatus() {
        let status = [];
        this.$store.getters["einstellungen/einstellung"]("mitgliederstatus").status.forEach((item) => {
          status.push(item.status);
        });
        return status;
      },
      felder() {
        const kontaktfelder = this.$store.getters["einstellungen/einstellung"]("kontaktfelder");
        return kontaktfelder === undefined ? {} : kontaktfelder;
      },
      isBilderwart() {
        return this.$route.params.seite === "Bilderwart";
      },
      kassen() {
        return this.$store.state.einstellungen.einstellungen.find((item) => item.id === "kassen");
      },
      disableSEPA() {
        return (
          !this.bbr.bic ||
          !this.bbr.kontoinhaber ||
          !this.bbr.mandatsreferenz ||
          !this.bbr.mandatUnterschriftsdatum ||
          !this.bbr.letzterLastschrifteinzug
        );
      },
      formatGeburtstagDatum() {
        if (!this.bbr.geburtsdatum) return null;
        return new Date(this.bbr.geburtsdatum).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
      formatReceptionsDatum() {
        if (!this.bbr.receptionsdatum) return null;
        return new Date(this.bbr.receptionsdatum).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
      formatPhilistrierungsDatum() {
        if (!this.bbr.philistrierungsdatum) return null;
        return new Date(this.bbr.philistrierungsdatum).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
      formatHochzeitsDatum() {
        if (!this.bbr.hochzeitsdatum) return null;
        return new Date(this.bbr.hochzeitsdatum).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
      formatTodesDatum() {
        if (!this.bbr.todesdatum) return null;
        return new Date(this.bbr.todesdatum).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
      formatletzterLastschrifteinzug() {
        if (!this.bbr.letzterLastschrifteinzug) return null;
        return new Date(this.bbr.letzterLastschrifteinzug).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
      formatmandatUnterschriftsdatum() {
        if (!this.bbr.mandatUnterschriftsdatum) return null;
        return new Date(this.bbr.mandatUnterschriftsdatum).toLocaleString(["de-de"], {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      },
    },
    methods: {
      saveData(value, feld) {
        this.bbr[feld.value] = value;
        // schaut welche Pflichtfelder noch nicht ausgefüllt sind und gibt ein Array mit den Labels zurück.
        let fields = [
          { field: "anrede", label: "Anrede" },
          { field: "vorname", label: "Vorname" },
          { field: "nachname", label: "Nachname" },
          { field: "adresse", label: "Adresse" },
          { field: "plz", label: "PLZ" },
          { field: "ort", label: "Ort" },
          { field: "status", label: "Status" },
          // { field: 'smart_meter_gateway_nummer_neu', label: 'SMGW Nummer', rule: this.rules.smgwNummer },
        ];
        this.pflichtfelder = fields
          .filter(({ field, rule }) => {
            const value = this.bbr[field];
            return !value || (rule && rule(value) !== true);
          })
          .map(({ label }) => label);
      },
      save() {
        console.log(this.bbr);
        this.$store.dispatch("bbrbbr/createBbr", this.bbr);
        this.bbr = {};
        this.close();
      },
      clickHochladenLastschriftmandat() {
        console.log("clickHochladenLastschriftmandat");
        this.loadingLaschriftmandatHochladen = true;
        window.addEventListener("focus", () => {}, { once: true });

        this.$refs.uploader.click();
      },
      onFileChanged(e) {
        this.selectedFile = e.target.files[0];
        const fileName = new Date().getSeconds();
        const storagePath = `/sepaLastschriftmandat/${this.$vars.verbindung}/`;
        const storageRef = this.$firebase
          .storage()
          .ref(storagePath + fileName)
          .put(this.selectedFile);
        storageRef.on(
          `state_changed`,
          (snapshot) => {
            console.log((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          },
          (error) => {
            console.log(error.message);
          },
          () => {
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.bbr.sepaLastschriftmandat = {
                url: url,
                date: new Date(),
                name: "SEPA-Lastschrift-" + new Date().getSeconds(),
              };
              this.loadingLaschriftmandatHochladen = false;
            });
          }
        );
      },
      downloadLastschrift(file) {
        var link = document.createElement("a");
        link.setAttribute("href", file.url);
        link.setAttribute("download", file.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      previewImage(event) {
        this.message = "";
        this.uploadValue = 0;
        this.img1 = null;
        this.imageData = event;
        this.onUpload();
      },
      async checkIban() {
        if (this.bbr.iban) {
          try {
            this.loading_checkIban = true;
            const url = `https://openiban.com/validate/${this.bbr.iban}?getBIC=true&validateBankCode=true`;
            const response = await axios.get(url);
            if (response.data.valid) {
              this.bbr.bic = response.data.bankData.bic;
              this.bbr.kontoinhaber = this.bbr.vorname + " " + this.bbr.nachname;
              this.bbr.mandatsreferenz = (
                this.bbr.vorname.slice(0, 3) +
                this.bbr.nachname.slice(0, 3) +
                Math.floor(Math.random() * 90000000 + 10000000)
              ).toUpperCase();
              this.bbr.mandatUnterschriftsdatum = new Date().toISOString().substr(0, 10);
              console.log(new Date().toISOString().substr(0, 10));
              this.bbr.letzterLastschrifteinzug = new Date().toISOString().substr(0, 10);
              this.fehlerSepa.sepa = null;
            } else {
              this.bbr.bic = "";
              Object.keys(this.sepa).forEach((key) => {
                this.sepa[key] = false;
              });
              this.fehlerSepa.sepa = "Die IBAN ist nicht korrekt.";
            }
            this.loading_checkIban = false;
          } catch (error) {
            console.error("Fehler beim Abrufen der IBAN:", error);
            this.loading_checkIban = false;
          }
        } else {
          this.bbr.bic = "";
        }
      },
      addKontoinhaber() {
        this.bbr.kontoinhaber = this.bbr.vorname + " " + this.bbr.nachname;
      },
      onUpload() {
        this.img1 = null;
        const storageRef = this.$firebase
          .storage()
          .ref(`/ahnengalerie/${this.bbr.nachname + this.bbr.vorname}`)
          .put(this.imageData);
        storageRef.on(
          `state_changed`,
          (snapshot) => {
            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          (error) => {
            console.log(error.message);
          },
          () => {
            this.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.img1 = url;
              this.bbr.bildAhnengalerie = this.img1;
              this.$store.dispatch("bbrbbr/updateBbrData", this.bbr);
              this.message = "Upload erfolgreich";
              this.selectPicture = "";
            });
          }
        );
      },
      close() {
        this.$emit("close", false);
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// dialogKontaktCreate.vue?6c7d5510